import {
  Accordion,
  AccordionSummary,
  Divider,
  Grid,
  AccordionDetails,
  ImageList,
  ImageListItem,
} from '@mui/material';
import { AmazonListing } from '../amazonModel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  value: AmazonListing | null;
  currency: string;
}

export default function AmazonListingDisplay({ value, currency }: Props) {
  return (
    value && (
      <Accordion sx={{ border: 1 }}>
        <AccordionSummary
          sx={{ borderBottom: 3 }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Grid container>
            <Grid item xs={12} sx={{}}>
              <h4 style={{ padding: 0, margin: 0 }}>Amazon {value.countryCode}</h4>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Price
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              UPC
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              ASIN
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              # Mpn
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Quantity
            </Grid>
            <Grid
              item
              xs={2}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Images
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              ${value.catalogProduct.prices.find((x) => x.currency === currency)?.price}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.catalogProduct.upc}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value?.asin}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value?.catalogProduct.crossReferences.length}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.catalogProduct.inStockQuantity}
            </Grid>
            <Grid item xs={2} sx={{ textAlign: 'center' }}>
              {value.catalogProduct.images.length}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Title
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Site Path
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'center' }}>
              {value?.title}
            </Grid>
            <Grid item xs={6} sx={{ textAlign: 'center' }}>
              {value?.marketplaceCategoryMappingNodePath}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#262626' }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Category
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Brand
            </Grid>
            <Grid item xs={6}>
              {value?.categoryName} &gt; {value.subCategoryName} &gt;{' '}
              {value?.marketplaceCategoryName}
            </Grid>
            <Grid item xs={6}>
              {value.catalogProduct.brand}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Description
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Bullet Points
            </Grid>
            <Grid item xs={6}>
              <div
                style={{ maxHeight: 350, overflow: 'auto' }}
                dangerouslySetInnerHTML={{ __html: value?.description }}
              />
            </Grid>
            <Grid item xs={6}>
              <ol>
                {value.bulletPoints.map((x) => (
                  <li>{x.value}</li>
                ))}
              </ol>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Attributes
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ textAlign: 'center', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Dimensions
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  Type
                </Grid>
                <Grid item xs={8} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  Value
                </Grid>
                {value.attributes.map((x) => (
                  <>
                    <Grid item xs={4} sx={{ textAlign: 'right' }}>
                      {x.attributeTypeName}:
                    </Grid>
                    <Grid item xs={8}>
                      {x.alternateValue}
                    </Grid>
                  </>
                ))}
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Length:
                </Grid>
                <Grid item xs={6}>
                  {value.catalogProduct.length}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Width:
                </Grid>
                <Grid item xs={6}>
                  {value.catalogProduct.width}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Height:
                </Grid>
                <Grid item xs={6}>
                  {value.catalogProduct.height}"
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  Weight:
                </Grid>
                <Grid item xs={6}>
                  {value.catalogProduct.weight} lb(s)
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <ImageList sx={{ width: 900, height: 250 }} cols={5} rowHeight={164}>
                {value.catalogProduct.images.map((x) => (
                  <ImageListItem key={x.imageUrl}>
                    <img
                      srcSet={`${x.imageUrl}?w=164&h=164`}
                      src={`${x.imageUrl}?w=164&h=164`}
                      alt=""
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
}
